<template>
  <div class="informations">
    <div class="informations-conten">
      <div class="informations-conten-list">
        <div class="informations-conten-list-left">头像</div>
        <div class="informations-conten-list-right1">
          <van-uploader :after-read="afterRead">
            <div style="display: flex; align-items: baseline">
              <div class="informations-conten-list-right1-left">
                <img :src="avatar" alt="" v-if="avatar != ''" />
                <img src="@/assets/img/图层_46.png" alt="" v-else />
                <img src="@/assets/img/xj.png" alt="" />
              </div>
              <div class="informations-conten-list-right1-right">
                <img src="@/assets/img/形状_4.png" alt="" />
              </div>
            </div>
          </van-uploader>
        </div>
      </div>
      <div class="informations-conten-list">
        <div class="informations-conten-list-left">姓名</div>
        <div class="informations-conten-list-right2">
          <van-field v-model="name" />
          <van-icon name="edit" size="10" />
        </div>
      </div>
      <div class="informations-conten-list">
        <div class="informations-conten-list-left">性别</div>
        <div class="informations-conten-list-right3">
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio name="男" checked-color="#E60012">男</van-radio>
            <van-radio name="女" checked-color="#E60012" style="margin-right: 0">
              女
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="informations-conten-list">
        <div class="informations-conten-list-left">身份</div>
        <div class="informations-conten-list-right4">
          <van-dropdown-menu :overlay="false" active-color="#E60012">
            <van-dropdown-item v-model="dropdownValue" :options="options" />
          </van-dropdown-menu>
        </div>
      </div>
    </div>
    <div class="informations-button" @click="save">保存</div>
    <!-- 底部 -->
    <div class="Foot">
      <div class="w">
        <div class="Foot-top">
          <img class="img" src="@/assets/img/logo2.png" alt="" />
          <div class="text1">联系方式</div>
          <div class="text2">0752-5333315</div>
          <div class="text3">惠州市西顿工业发展有限公司 粤ICP备07509439号</div>
        </div>
        <div class="Foot-bottom">粤公网安备44130202000046号</div>
      </div>
    </div>
  </div>
</template>

<script>
import { $get_user_info, $get_identity, $edit_user_info, $upload } from "@/api";
export default {
  data () {
    return {
      avatar: "", // 头像地址
      uploadAvatar: "", // 上传头像的地址
      name: "大鱼海棠", // 名字
      radio: "男", // 性别
      // 身份的下拉选择器数据
      options: [],
      dropdownValue: "", // 身份
    };
  },
  async mounted () {
    try {
      let res = await $get_user_info();
      this.avatar = res.data.avatar;
      this.name = res.data.real_name;
      this.dropdownValue = res.data.identity;
      this.radio = res.data.gender == 1 ? "男" : "女";

      let res1 = await $get_identity();
      this.options = res1.data.map((item) => ({
        value: item.id,
        text: item.identity_name,
      }));
      this.options.forEach((item) => {
        if (item.text == this.dropdownValue) {
          this.dropdownValue = item.value;
        }
      });
    } catch (error) { }
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          if (document.documentElement.clientWidth > 767) {
            this.$router.push({ name: "information", query: { index: 1 } });
          }
        });
      })();
    };
  },
  beforeDestroy () {
    window.onresize = null;
  },
  methods: {
    // 文件上传完毕后会触发 after-read 回调函数
    async afterRead (file) {
      let formData = new FormData();
      formData.append("file", file.file);
      try {
        let res = await $upload(formData);
        this.avatar = res.data.url;
        this.uploadAvatar = res.data.image;
      } catch (error) { }
    },
    // 点击保存按钮
    async save () {
      try {
        let params = {
          avatar: this.uploadAvatar,
          real_name: this.name,
          identity: this.dropdownValue,
          gender: this.radio == "男" ? 1 : 2,
        };
        let res = await $edit_user_info(params);
        this.$toast.success("保存成功");
      } catch (error) { }
    },
  },
};
</script>

<style lang="less" scoped>
.informations {
  position: relative;
  background: #f5f7fb;
  min-width: 100vw;
  min-height: 100vh;
  padding-top: 12px;

  .informations-conten {
    // width: 343px;
    width: 90%;
    background: #ffffff;
    margin: 0 auto;
    padding: 18px 20px 23px 17px;

    .informations-conten-list {
      padding: 20px 0;
      border-bottom: 1px solid #efefef;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .informations-conten-list-left {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .informations-conten-list-right1 {
        .informations-conten-list-right1-left {
          margin-right: 12px;
          position: relative;

          img:nth-child(1) {
            border-radius: 50%;
            width: 54px;
            height: 54px;
          }

          img:nth-child(2) {
            width: 18px;
            height: 18px;
            position: absolute;
            top: 63%;
            right: 1%;
          }
        }

        .informations-conten-list-right1-right {
          width: 4px;
          height: 7px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .informations-conten-list-right2 {
        display: flex;
        align-items: center;

        /deep/.van-cell {
          padding: 0;
          width: 61px;
          margin-right: 9px;
        }

        /deep/.van-cell::after {
          border: 0px solid #000;
        }
      }

      .informations-conten-list-right3 {
        /deep/.van-radio--horizontal {
          margin-right: 26px;
        }

        /deep/.van-radio__label {
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }

      .informations-conten-list-right4 {
        /deep/.van-dropdown-menu__bar {
          height: 20px;
          box-shadow: 0 2px 12px #fff;
        }

        /deep/.van-popup--top {
          width: 40%;
          left: 54%;
          top: 12px;
        }

        /deep/ .van-dropdown-menu {
          // width: 0;
          // height: 0;
          .van-dropdown-menu__bar {
            height: 100%;
          }

          .van-dropdown-menu__title {
            padding-right: 30px;
          }

          .van-dropdown-menu__title::after {
            border-color: transparent transparent #333333 #333333;
            margin-top: -6px;
            right: 5px;
            width: 13px;
            height: 13px;
            opacity: 1;
            transform: rotate(-135deg);
          }

          .van-dropdown-menu__title--down::after {
            margin-top: -10px;
            transform: rotate(-45deg);
          }
        }
      }
    }
  }

  .informations-button {
    // width: 306px;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    // bottom: 5%;
    width: 70%;
    height: 50px;
    background: #e60012;
    border-radius: 5px;
    margin: 30px auto;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin: 0 auto;

    .w {
      // width: 1280px;
      margin: 0 auto;
    }

    .Foot-top {
      background: #ffffff;
      padding-top: 24px;
      padding-bottom: 15px;
      padding-left: 46px;
      padding-right: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .img {
        width: 116px;
        height: 15px;
        margin-bottom: 24px;
        object-fit: cover;
      }

      .text1 {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 16px;
      }

      .text2 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #e60000;
        margin-bottom: 12px;
      }

      .text3 {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 20px;
        text-align: center;
      }
    }

    .Foot-bottom {
      width: 100%;
      height: 48px;
      background: #f9f9f9;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>